var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({'background-color': '#d6d6d6', padding: '8px', 'font-size': _vm.fontSize, 'border-radius': _vm.borderRadius, border: _vm.border})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }